<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计与监控</el-breadcrumb-item>
      <el-breadcrumb-item>每天佩戴统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <!-- 批量导出每天佩戴统计 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clickexcel">批量导出每天佩戴统计</el-button>
          </el-form-item>
        </el-form>
        <!-- 批量导出每天佩戴统计 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Loginname" label="登录名称" min-width="8%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="5%"></el-table-column>
          <el-table-column prop="Sexs" label="性别" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="电话号码" min-width="9%"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="12%"></el-table-column>
          <el-table-column label="初始裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreef" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreef" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreef" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column label="最新裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreel" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreel" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreel" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column prop="Createtime" label="注册时间" min-width="12%"></el-table-column>
          <el-table-column label="操作" min-width="5%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDailyDetails(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="查看详情" name="second" disabled="disabled">
        <DailyDetails ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></DailyDetails>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import DailyDetails from '@/componentsSubVue/DailyDetails.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    DailyDetails
  },
  name: 'MyDaily',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        name: '',
        phone: '',
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        chaoqi: '1',
        registertype: '0',
        bomsn: '',
        saletype: '0',
        diopterstate: '0',
        begintime: '',
        endtime: ''
      }
    }
  },
  mounted () {
    this.apigetcustomernum()
    this.apigetcustomerlist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetcustomerlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetcustomernum()
      this.apigetcustomerlist()
    },
    clickexcel () {
      this.apiExcelDaily()
    },
    clickAdd () {
      this.apiaddcustomer()
    },
    // 查看详情
    goDailyDetails (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { userid: row.Id, Jigouname: row.Jigouname, Name: row.Name, Age: row.Age } })
    },
    apigetcustomerlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        chaoqi: that.keywords.chaoqi,
        registertype: that.keywords.registertype,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              var Sexs = '男'
              if (item1.Sex == 2) Sexs = '女'
              var Usestates = '否'
              if (item1.Usestate == 2) Usestates = '是'
              var Ipaddress = item1.Ip + '(' + item1.Ipprovince + item1.Ipcity + ')'
              that.dataList.push({ Id: item1.Id, Loginname: item1.Loginname, Name: item1.Name, Age: item1.Age, Sex: item1.Sex, Sexs: Sexs, Phone: item1.Phone, Jigouid: item1.Jigouid, Jigouname: item1.Jigouname, Mac: item1.Mac, Cardnumber: item1.Cardnumber, Nakedrighteyedegreef: item1.Nakedrighteyedegreef, Nakedlefteyedegreef: item1.Nakedlefteyedegreef, Nakedbinoculusdegreef: item1.Nakedbinoculusdegreef, Nakedrighteyedegreel: item1.Nakedrighteyedegreel, Nakedlefteyedegreel: item1.Nakedlefteyedegreel, Nakedbinoculusdegreel: item1.Nakedbinoculusdegreel, Usestate: item1.Usestate, Usestates: Usestates, Delaytime: item1.Delaytime, Createtime: item1.Createtime, Ip: item1.Ip, Ipprovince: item1.Ipprovince, Ipcity: item1.Ipcity, Ipaddress: Ipaddress, Provinceid: item1.Provinceid, Cityid: item1.Cityid, Districtid: item1.Districtid, Address: item1.Address, Speedstate: item1.Speedstate })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetcustomernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        chaoqi: that.keywords.chaoqi,
        registertype: that.keywords.registertype,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelDaily: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelDaily, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
